import axios from '../axiosConfig'
import { getEnv } from '@utils/env'
import type { DashboardPeriod } from './finance.api'

const BUSINESS_LAYER_API = getEnv('REACT_APP_BUSINESS_LAYER_DASHBOARD')

interface ApiResponse<T> {
  statusCode: number
  message: string
  data: T
}

export interface DiagnosedTreatmentQueryParams {
  clinicId: string
  date: string
  period: DashboardPeriod
}

export interface DiagnosedTreatmentKpiData {
  diagnosedTreatmentCount: string
  diagnosedTreatmentGoal: string
}

export interface DiagnosedTreatmentOverviewResult {
  period: DashboardPeriod
  periodStart: string
  periodEnd: string
  goals: null
  kpis: DiagnosedTreatmentKpiData
}

const diagnosedTreatmentGet = <T>(
  path: string,
  params: DiagnosedTreatmentQueryParams,
  options?: { signal?: AbortSignal },
): Promise<T> =>
  axios
    .get<
      ApiResponse<T>
    >(`${BUSINESS_LAYER_API}/api/v1/dashboard/treatment/diagnosed/${path}`, { params, signal: options?.signal })
    .then((response) => response.data.data)

export const getDiagnosedTreatmentOverview = (
  params: DiagnosedTreatmentQueryParams,
  options?: { signal?: AbortSignal },
): Promise<DiagnosedTreatmentOverviewResult> =>
  diagnosedTreatmentGet('overview', params, options)
